/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserByRoleRes } from '../../models/user-by-role-res';

export interface ApiRoleCheckUserByRolePost$Params {
  roleCode?: string;
}

export function apiRoleCheckUserByRolePost(http: HttpClient, rootUrl: string, params?: ApiRoleCheckUserByRolePost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserByRoleRes>>> {
  const rb = new RequestBuilder(rootUrl, apiRoleCheckUserByRolePost.PATH, 'post');
  if (params) {
    rb.query('roleCode', params.roleCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserByRoleRes>>;
    })
  );
}

apiRoleCheckUserByRolePost.PATH = '/api/role/check-user-by-role';
